import { useTranslation } from 'react-i18next';
import { navigateToWorkbench } from 'app/routes';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { ShowDetailsButton } from 'app/components/features/NotificationHub/ShowDetailsButton.jsx';

export function NotebookSqlNodeCreatedNotification({ id, onDismiss, viewRef }) {
    const { t } = useTranslation();

    const handleClickDetails = () => {
        navigateToWorkbench(viewRef.spaceSlug, viewRef.viewUid);
    };

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled variant={SnackbarVariant.SUCCESS}>
            <SnackbarMessage>
                {t('notifications:notebookSqlNodeCreated', {
                    name: viewRef.viewName,
                    project: viewRef.spaceName
                })}
            </SnackbarMessage>
            <ShowDetailsButton
                i18nKey="notifications:notebookSqlNodeCreatedDetailsButton"
                id={id}
                onClick={handleClickDetails}
            />
        </Snackbar>
    );
}
